import { forEach } from "lodash";
import { SingleSelectOption } from "@/components/controls/SingleSelect";
import { CampaignType } from "@/pages/leads/types";

export const getCampaignTypeOptions = (
  campaignTypes: CampaignType[]
): SingleSelectOption[] => {
  const campaignTypeOptions: SingleSelectOption[] = [];
  forEach(campaignTypes, (campaignType) => {
    campaignTypeOptions.push({
      id: campaignType.id,
      displayName: campaignType.name
    });
  });
  return campaignTypeOptions;
};
